import React from 'react';
import styled from 'styled-components';
import YouTubeSquare from 'icons/src/YouTubeSquare';
import Linkedin from 'icons/src/Linkedin';
import InstragramSquare from 'icons/src/InstragramSquare';
import X from 'icons/src/X';
import FacebookSquare from 'icons/src/FacebookSquare';
import TikTok from 'icons/src/TikTok';
import Whatsapp from 'icons/src/Whatsapp';
import Button from './button/index';
import useWhatsappLink from '../hooks/use-whatsapp-link';

const Socialmedia = ({
  className,
  facebook,
  youtube,
  linkedin,
  instagram,
  twitter,
  tiktok,
}) => {
  // todo, settable:
  const whatsappLink = useWhatsappLink('Ik heb een vraag via de website: ');

  return (
    <div className={className}>
      {facebook && (
        <StyledButton
          nth={[facebook].filter(Boolean).length - 1}
          aria-label="Ga naar Facebook"
          href={facebook}
        >
          <Icon as={FacebookSquare} />
        </StyledButton>
      )}
      {twitter && (
        <StyledButton
          nth={[facebook, twitter].filter(Boolean).length - 1}
          aria-label="Ga naar Twitter"
          href={twitter}
        >
          <Icon as={X} />
        </StyledButton>
      )}
      {instagram && (
        <StyledButton
          nth={[facebook, twitter, instagram].filter(Boolean).length - 1}
          aria-label="Ga naar Instagram"
          href={instagram}
        >
          <Icon as={InstragramSquare} />
        </StyledButton>
      )}
      {linkedin && (
        <StyledButton
          nth={[facebook, twitter, instagram, linkedin].filter(Boolean).length - 1}
          aria-label="Ga naar LinkedIn"
          href={linkedin}
        >
          <Icon as={Linkedin} />
        </StyledButton>
      )}
      {youtube && (
        <StyledButton
          nth={[facebook, twitter, instagram, linkedin, youtube].filter(Boolean).length - 1}
          aria-label="Ga naar YouTube"
          href={youtube}
        >
          <Icon as={YouTubeSquare} />
        </StyledButton>
      )}
      {tiktok && (
        <StyledButton
          nth={[facebook, twitter, instagram, linkedin, youtube, tiktok].filter(Boolean).length - 1}
          aria-label="Ga naar TikTok"
          href={tiktok}
        >
          <Icon as={TikTok} />
        </StyledButton>
      )}
      {whatsappLink && (
        <StyledButton
          nth={[
            facebook,
            twitter,
            instagram,
            linkedin,
            youtube,
            tiktok,
            whatsappLink,
          ].filter(Boolean).length - 1}
          aria-label="Bericht op WhatsApp"
          href={whatsappLink}
        >
          <Icon as={Whatsapp} />
        </StyledButton>
      )}
    </div>
  );
};

const Icon = styled.svg``;

const StyledButton = styled(Button).attrs({
  wrapper: true,
})`
  ${Icon} {
    width: 2.5rem;
    height: 2.5rem;
  }
`;

export default styled(Socialmedia)`
  display: flex;
  flex-direction: row;
  gap: 0.333rem;
`;
